import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  heading: {
    fontSize: "1.5rem",
    fontWeight: 500,
    color: "#1C1B1F",
  },
  subheading: {
    fontSize: "0.875rem",
    color: "#535353",
  },
  thumbnail: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    borderRadius: "0.5rem",
  },
  offerCard: {
    padding: theme.spacing(2.5),
    backgroundColor: "rgba(247,37,54, 0.1)",
    color: "#1C1B1F",
    borderRadius: "5px",
  },
  offerCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  offerCardHeading: {
    fontSize: "1rem",
    fontWeight: 500,
  },
  offerCardSaveBadge: {
    display: "grid",
    placeItems: "center",
    width: "89px",
    height: "23px",
    color: "#FFFFFF",
    backgroundColor: "#39DB79",
    borderRadius: "6px",
    fontSize: "1rem",
    fontWeight: 500,
  },
  offerCardDescription: {
    fontSize: "0.625rem",
    color: "#535353",
  },
  offerCardFeatures: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2.5),
  },
  offerCardFeature: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
  },
  checkCircle: {
    display: "grid",
    placeItems: "center",
    backgroundColor: "#39DB79",
    color: "#FFFFFF",
    borderRadius: "50%",
    width: "1rem",
    height: "1rem",
  },
  offerCardFeatureText: {
    fontSize: "0.625rem",
    color: "#1C1B1F",

    "& > span": {
      color: theme.palette.secondary.main,
      fontWeight: 700,
    },
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(6),
    marginTop: theme.spacing(4),
  },
  cta: {
    width: "100%",
    height: "2.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
    color: "#FFFFFF",
    border: "none",
    borderRadius: "55px",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  continueButton: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#535353",
    backgroundColor: "transparent",
    border: "none",
  },
}));
